import { render } from "./ReferralPersonSection.vue?vue&type=template&id=d1d29272&scoped=true"
import script from "./ReferralPersonSection.vue?vue&type=script&lang=js"
export * from "./ReferralPersonSection.vue?vue&type=script&lang=js"

import "./ReferralPersonSection.vue?vue&type=style&index=0&id=d1d29272&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1d29272"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QChip,QIcon});
